export default "__VITE_ASSET__xeShZPxS__"